export const environment = {
  production: false,
  color: 'accent',
  title: 'Dev Nabel Customer Portal',
  title_xs: 'Dev NCP',
  projectName: "dev-nabel-customer-portal",
  host: 'dev-nabel-customer-portal.appspot.com',
  origin: 'dev.nabel-customer-portal.com',
  algoliaIndex: {
    nouhinSeikyuusho: 'nouhinSeikyuusho-dev',
    tokuisaki: 'tokuisaki-dev'
  },
  firebaseConfig: {
    apiKey: "AIzaSyDJW4XC12yeQaSgqjVeVpnBJSk0mJ9VhiI",
    authDomain: "dev.nabel-customer-portal.com",
    projectId: "dev-nabel-customer-portal",
    storageBucket: "dev-nabel-customer-portal.appspot.com",
    messagingSenderId: "627208666676",
    appId: "1:627208666676:web:7db95a24b4cdb284bf5461"
  },

};
